<div class="container">
  <section>
    <h1 id="off-site-policy">M-Catering Off-Site Catering Policies</h1>
    <p>(events hosted in places other than within University Unions facilities)</p>
    <h2>General Policies</h2>
    <p>All catered events are subject to:</p>
    <ul>
      <li>$600 minimum on food and beverage sales per meal period (multiple trucking fees may apply)</li>
      <li>$1000 minimum for Sunday-only events that are not part of a larger, multi-day event.</li>
      <li>$100 minimum on food and beverage sales for Student Group drop off events only (Fifteen (15) minute delivery
        window) ($500 minimum on food and beverage sales on Sunday)</li>
      <li>Pick up ONLY events that are small in revenue and are specific to student groups are encouraged and have no
        minimum. Items can be picked up from League (Maizies), Pierpont (Blue Market-Pierpont Commons), Union (Blue
        Market-Union).</li>
      <li>We do not provide beverage only services.</li>
      <li>State of Michigan sales tax &ndash; commercial groups</li>
      <li>20% service fee ($35 minimum gratuity)</li>
      <li>$70 delivery/trucking fee, additional delivery times are charge based on number of truck runs (for all
        Non-Union Buildings)</li>
      <li>$35 delivery/trucking fee for drop off orders.</li>
      <li>Private Home Delivery based on $1,000 minimum food and beverage sales</li>
      <li>No business accepted within 6 business days</li>
      <li>Delivery only events do NOT include any rental linen provided by M|Catering</li>
      <li>Events that require 20 linens or more will be assessed a minimum of $25.00 hourly staff fee (2 hour min for
        set up/tear down)</li>
      <li>Boxed/bagged lunches or salads are provided as delivery ONLY unless associated with additional meal services
        and would then be charged the applicable delivery fees.</li>
      <li>Michigan Hospital deliveries and events will be filtered to our Catering To Go Program unless event style/size
        qualifies for on site Catering Staff.</li>
      <li>Bagged and boxed lunches over 30 will be served lunchbox creation style or deconstructed.</li>
      <li>Compostable serviceware is included in all pricing of menu items.  If additional plates, napkins, flatware or cups are requested or required based on the style of service additional fees may be applicable.</li>
    </ul>
    <p>In order to comply with local health department regulations, all perishable left-overs must be discarded by
      Michigan Catering. Michigan Catering works closely with Food Gatherers and Maize and Blue Pantry to donate unused
      food items. All prices
      are subject to change. Food and beverage pricing can be confirmed a maximum of two months in advance with menu
      selection. Hours of operation and access restrictions vary widely across campus. Please ensure that accurate
      details are communicated
      to your event manager at the time of booking to ensure timely service.</p>
    <h2>Guest Guarantees</h2>
    <p>Accurate counts, special dietary information, and plated meal designations all help to optimize service. The
      final guaranteed count (and any applicable special dietary information and meal designations) must be provided a
      minimum of six business days prior to the event. This number is considered final and cannot be reduced. Increases
      in guest count will be honored whenever possible, but are not guaranteed and may be subject to a rush fee. The
      final food and beverage charge will be based on the guaranteed count or actual number served, whichever is greater
    </p>
    <h2>Cancellations</h2>
    <p>While reasonable effort will be made to minimize cancellation charges, groups will be held responsible for all
      charges incurred as a result of any commitments made to facilitate the event. Events canceled within three (3)
      business days may be
      charged up to 100% of the total estimated food and beverage charges.</p>
    <h2>Service Styles</h2>
    <p>In addition to full service, Michigan Catering offers the following types of limited service. Please discuss your
      event needs with your Event Manager to determine the most appropriate service for your needs.</p>
    <p><strong>DROP OFF SERVICE</strong> (served with compostable items, set up included) The trays and utensils
      (disposables) provided with your food-only deliveries are yours to keep or dispose of at your leisure. Drop off
      subject to
      delivery/trucking fees.</p>
    <p><strong>PICK-UP ORDERS</strong> All pick-up orders will be presented on disposable products. Pick-ups can occur
      M-F, 8am-7pm at Pierpont Commons, Michigan League and Michigan Union. Subject to 20% gratuity.</p>
    <h2>Payment Policies</h2>
    <p>University Departments and student organizations must pay with a University Short Code.</p>
    <p>Student organizations must deposit adequate funds to cover all charges in their S.O.A.S. accounts no later than
      one week prior to the scheduled function.</p>

    <p>Commercial events may require a minimum food and beverage expenditure (tax and gratuity not included) based on
      venue, day of week and time of day. Please see an Event Service Representative for specifics. Six months prior to
      the event, if a food and beverage minimum is applied, a payment of 50% of the food and beverage minimum is due.
      Six days prior to the event, funds to adequately cover the balance of all charges must be paid in the form of:</p>
    <ul>
      <li>a Visa, Master Card, American Express or Discover credit card payment via a secure payment link or
      </li>
      <li>a cashier’s check or money order payable to "the Regents of the University of Michigan"</li>
    </ul>
    <p>When possible, all refunds will be distributed in the same form as payment method after accounting is complete.
    </p>
    <h2>Nutrition</h2>
    <ul>
      <li>Please refer to <a href="http://fss.studentlife.umich.edu/NetNutrition/1" target="_blank"
          rel="noopener">MyNutrition</a> to identify allergens, nutritional values and ingredients for menu items. You
        may also contact one of our dietitians at
        <a href="tel:+17347643000">734-764-3000</a>.
      </li>
    </ul>
    <h2>Alcohol Service</h2>
    <p>Michigan Catering&rsquo;s Off-Site Catering does not hold an off premise catering liquor permit. The client is
      therefore responsible for providing the alcohol and the special license. A special license is not required if all
      of the following
      conditions apply:</p>
    <ul>
      <li>the event is free of charge</li>
      <li>the event is by invitation only (not open to the public)</li>
      <li>no regular liquor inventory is kept</li>
      <li>the event must be monitored by a designated responsible individual, and all servers are TAM or TIPS-certified
      </li>
    </ul>
    <ol>
      <li>Full Catering and Alcohol Service When Michigan Catering is contracted for the catered food in addition to the
        service of the client-provided alcohol, the following charges apply:</li>
      <ul>
        <li>$50 set up fee per bar - this fee covers all bartenders, disposable glasses, ice, and garnishes. Glassware
          available for rental.</li>
        <li>Wine Service Only</li>
        <ul>
          <li>With this option, we are contracted to hand pass or serve client-provided wines as part of dinner service.
            Glassware available for rental. Subject to hand passer fee of $25 per hour/passer</li>
        </ul>
      </ul>
      <li>Alcohol Service Only (Rackham Only)When Michigan catering is contracted solely for the service of alcohol, at
        Rackham Graduate School, the following charges apply.</li>
      <ul>
        <li>Off-site host bar set up set up fee of $250/hour</li>
        <li>Additional bartender $100/hour</li>
        <li>Trucking/Delivery fee $70</li>
      </ul>
    </ol>
    <p>We are happy to offer bartending services and facilitate orders and deliveries, but all alcohol must be paid for
      separately from Michigan Catering. By law our staff is not permitted to receive, purchase or transport alcohol;
      this is the
      responsibility of the client.</p>
    <p>An off&ndash;site bar service agreement must be signed.</p>
    <p>At all events where alcohol is to be present, food of a substantial nature must be provided for the guests by the
      host. For receptions, food of a substantial nature is equivalent to a minimum of three hors d'oeuvre portions per
      person attending the event for each hour of bar service.</p>
    <!-- <p>Bar service is limited to four hours. For events including a full meal service, one hour of wine service may be
      added during meal service. Bar service may begin no earlier than one hour prior to meal service and must end one
      hour prior to the end of the event.</p>
    <p>Under no circumstances can the overall alcohol service time exceed 4 hours of service or extend beyond the room
      reservation hours.</p> -->
    <p>Bar Service Guidelines for Events:</p>
    <ul>
      <li>Department and Student Events: Bar service is limited to four hours.</li>
      <li>Events Hosted by External Organizations: Alcohol service is limited to five hours.</li>
    </ul>
    <p>Important Time Restrictions:</p>
    <ul>
      <li>End Time: All alcohol service must end by 11:00 PM, regardless of the type of event.</li>
      <li>Meal Service: For department and commercial events with a full meal, you may add one hour of wine service during the meal.</li>
      <li>For external events, the wine service must be included in the five-hour maximum alcohol service time.</li>
      <li>Service Timing: Bar service can start no earlier than one hour before meal service begins and must end one hour before the event concludes.</li>
    </ul>
    <p>Changes to Service Times:</p>
    <ul>
      <li>Any changes to alcohol service times must be requested before the event starts.</li>
      <li>Changes can only happen if certified staff (TAM/TIPS) are available.</li>
      <li>All applicable charges must be reviewed and approved.</li>
    </ul>
    <p>All bartenders are trained in and observe the Techniques of Alcohol Management (TAM) or Training for Intervention
      Procedures (TIPS). In an effort to maintain the health and safety of guests, the following parameters apply to
      alcohol service.</p>
    <p>All drinks must be served with the appropriate amounts of mixers and ice. No straight shots of any liquor or
      combination of three or more liquors will be served. All beer, wine and mixed drinks will be provided in
      individual servings.</p>
    <h2>Exclusivity Clause</h2>
    <p>MCatering has exclusivity for food and beverage service in University Unions. MCatering proceeds directly support 
      Student Life, including University Unions, offering transformational student experiences by advancing student 
      learning and development, fostering well-being, and cultivating an inclusive and equitable campus community. 
      MCatering proceeds support:</p>
    <ul>
      <li>Student programs and resources offered through the Division of Student Life in areas such as the Center for 
        Campus Involvement, Multi-Ethnic Student Affairs, the Spectrum Center, Trotter Multicultural Center, and the 
        International Center</li>
      <li>Wellness Services</li>
      <li>Educational opportunities for students, student employees, and student organizations</li>
      <li>Hundreds of student employment opportunities</li>
    </ul>
    <p>MCatering further supports the university's commitment to 
      <a href="https://dining.umich.edu/sustainability/social-sustainability/social-equity/">diversity, equity, and 
      inclusion in dining</a>; local purchasing; and is a leader in achieving 
      <a href="https://dining.umich.edu/sustainability/environmental-sustainability/">campus sustainability goals</a>.
    </p>
    <p>For groups requiring cultural and regional menu offerings, we encourage you to visit the International and 
      Regional Menus on the <a href="https://catering.umich.edu/">MCatering Website</a>.  MCatering understands that food 
      is connected to stories, identities, experiences, and familial traditions. In our Regional Menu, we have organized 
      offerings by region rather than country or ethnicity. We are open to feedback to help ensure what is offered on the 
      menus is culturally recognizable for your event. We know that recipes can be diasporic, and may be influenced by 
      other regions, recipes, and traditions worldwide. Please feel free to request menu items from multiple regions and 
      let us know what ethnicities and experiences are influencing your decisions so our team can create the ideal menu 
      for you. It is noted on the menu if recipes originated from students and what country that student identified. 
    </p>
    <h2>Menu Pricing</h2>
    <p>All prices are subject to change. Food and beverage pricing can be confirmed a maximum of two months in advance
      with menu selection.</p>
    <h2>Leftover Food</h2>
    <p>Due to health department regulations, leftover perishable foods may not be removed from any event by anyone
      except food service staff. This policy addresses public safety concerns and is non-negotiable. However,
      non-perishable items such as
      whole fruit, baked goods, and canned sodas may be taken from events. Michigan Catering works closely with Food
      Gatherers, Food Recovery Network and Maize and Blue Pantry to donate unused food items.</p>
    <h2>Service Times</h2>
    <p>Buffet menu quantities and perishable items are limited to a two-hour service period unless noted otherwise. Food
      items will be removed at the end of the contracted service period to ensure food quality.</p>
  </section>
  <section>
    <h1 id="on-premise-policy">On-Premise Catering Policies</h1>
    <p>For events hosted within University Unions facilities</p>
    <h2>Gratuities and Fees</h2>
    <p>All catered events are subject to:</p>
    <ul>
      <li>$35.00 minimum food and beverage sales</li>
      <li>State of Michigan sales tax</li>
      <li>20% Gratuity ($35 minimum gratuity for department and commercial events)</li>
    </ul>
    <h2>Late Orders and Changes</h2>
    <p>While every effort will be made to accommodate last minute requests, in order to ensure quality of food and
      service, we prefer a minimum of one week notice for events. Ideally, food and beverage should be confirmed three
      weeks prior to the event
      date. <strong>Orders received within six (6) business days of an event will be assessed a rush fee of
        $50</strong>.</p>
    <h2>Exclusivity Clause</h2>
    <p>MCatering has exclusivity for food and beverage service in University Unions. MCatering proceeds directly support 
      Student Life, including University Unions, offering transformational student experiences by advancing student 
      learning and development, fostering well-being, and cultivating an inclusive and equitable campus community. 
      MCatering proceeds support:</p>
    <ul>
      <li>Student programs and resources offered through the Division of Student Life in areas such as the Center for 
        Campus Involvement, Multi-Ethnic Student Affairs, the Spectrum Center, Trotter Multicultural Center, and the 
        International Center</li>
      <li>Wellness Services</li>
      <li>Educational opportunities for students, student employees, and student organizations</li>
      <li>Hundreds of student employment opportunities</li>
    </ul>
    <p>MCatering further supports the university's commitment to 
      <a href="https://dining.umich.edu/sustainability/social-sustainability/social-equity/">diversity, equity, and 
      inclusion in dining</a>; local purchasing; and is a leader in achieving 
      <a href="https://dining.umich.edu/sustainability/environmental-sustainability/">campus sustainability goals</a>.
    </p>
    <p>For groups requiring cultural and regional menu offerings, we encourage you to visit the International and 
      Regional Menus on the <a href="https://catering.umich.edu/">MCatering Website</a>.  MCatering understands that food 
      is connected to stories, identities, experiences, and familial traditions. In our Regional Menu, we have organized 
      offerings by region rather than country or ethnicity. We are open to feedback to help ensure what is offered on the 
      menus is culturally recognizable for your event. We know that recipes can be diasporic, and may be influenced by 
      other regions, recipes, and traditions worldwide. Please feel free to request menu items from multiple regions and 
      let us know what ethnicities and experiences are influencing your decisions so our team can create the ideal menu 
      for you. It is noted on the menu if recipes originated from students and what country that student identified. 
    </p>
    <h2>Menu Pricing</h2>
    <p>All prices are subject to change. Food and beverage pricing can be confirmed a maximum of two months in advance
      with menu selection.</p>
    <h2>Leftover Food</h2>
    <p>Due to health department regulations, leftover perishable foods may not be removed from any event by anyone
      except food service staff. This policy addresses public safety concerns and is non-negotiable. However,
      non-perishable items such as
      whole fruit, baked goods, and canned sodas may be taken from events. Michigan Catering works closely with Food
      Gatherers, Food Recovery Network and Maize and Blue Pantry to donate unused food items.</p>
    <h2>Service Times</h2>
    <p>Buffet menu quantities and perishable items are limited to a two-hour service period unless noted otherwise. Food
      items will be removed at the end of the contracted service period to ensure food quality.</p>
    <h2>Water Service</h2>
    <p>Water service is available in the League, Union and Pierpont Commons. Additional costs may be associated
      depending on the type of food and beverage service your event entails. For services with no additional food or
      beverage, water services with
      glassware will be charged $1.00 per person (minimum $20, maximum $100.00). For services with no additional food or
      beverage, water services with compostables will be charged $.50 per person (minimum of $10, Maximum of $50.00)</p>
    <h2>Special Dietary Needs</h2>
    <p>We strongly encourage event planners to solicit special dietary needs from their attendees to ensure that all
      guests have a positive dining experience. Michigan Catering labels buffet items for the following allergens:</p>
    <ul>
      <li>Eggs</li>
      <li>Fish</li>
      <li>Gluten</li>
      <li>Milk</li>
      <li>Peanuts</li>
      <li>Shellfish</li>
      <li>Soy</li>
      <li>Tree nuts</li>
      <li>Wheat</li>
    </ul>
    <p>We use reasonable efforts in our food sourcing, preparation and handling procedures to avoid the introduction of
      allergens. However, we do not have separate allergy-friendly kitchens and are unable to guarantee that a menu item
      is completely
      free of allergens. Please let your Event Manager know if any of your attendees have allergies not included in the
      above list and/or life-threatening allergies.</p>
    <h2>Guest Guarantees</h2>
    <p>Accurate counts, special dietary information, and plated meal designations all help to optimize service. The
      final guaranteed count (and any applicable special dietary information and meal designations) must be provided a
      minimum of six business
      days prior to the event. This number is considered final and cannot be reduced. Increases in guest count will be
      honored whenever possible, but are not guaranteed and may be subject to a rush fee. The final food and beverage
      charge will be based
      on the guaranteed count or actual number served, whichever is greater</p>
    <h2>Cancellations</h2>
    <p>While reasonable effort will be made to minimize cancellation charges, groups will be held responsible for all
      charges incurred as a result of any commitments made to facilitate the event. Events canceled within three
      business days may be
      charged up to 100% of the total estimated food and beverage charges.</p>
    <h2>Payment Policies</h2>
    <p>University Departments and student organizations must pay with a University Short Code.</p>
    <p>Student organizations must deposit adequate funds to cover all charges in their S.O.A.S. accounts no later than
      one week prior to the scheduled function.</p>
    <p>Commercial events may require a minimum food and beverage expenditure (tax and gratuity not included) based on
      venue, day of week and time of day. Please see an Event Service Representative for specifics. Six months prior to
      the event, if a food
      and beverage minimum is applied, a payment of 50% of the food and beverage minimum is due. Six days prior to the
      event, funds to adequately cover the balance of all charges must be paid in the form of:</p>
    <ul>
      <li>a Visa, Master Card, American Express or Discover credit card payment via a secure payment link or</li>
      <li>a cashier&rsquo;s check or money order payable to "the Regents of the University of Michigan"</li>
    </ul>
    <p>When possible, all refunds will be distributed in the same form as payment method after accounting is complete.
    </p>
    <h2>Nutrition</h2>
    <ul>
      <li>Please refer to <a href="http://fss.studentlife.umich.edu/NetNutrition/1" target="_blank"
          rel="noopener">MyNutrition</a> to identify allergens, nutritional values and ingredients for menu items. You
        may also contact one of our dietitians at
        <a href="tel:+17347643000">734-764-3000</a>.
      </li>
    </ul>
    <h2>Alcohol Service</h2>
    <p>As a licensed facility, University Unions is subject to all rules and regulations of the State of Michigan's
      Liquor Control Commission. No alcohol other than that provided by University Unions may be served within our
      facilities. Additionally,
      no alcohol can be removed from the event room or University Unions facilities.</p>
    <p>All events where students are invited will require the submission of an Alcohol Disclosure Form, provided by the
      Event Manager. Events with student attendees (graduate or undergraduate) require wristbands, Department of Public
      Safety officers, and/or faculty/staff
      chaperones. In those cases, the group organizing the event may need to pay associated fees. Events organized by
      student organizations can only have cash bars.</p>
    <p>At all events where alcohol is to be present, food of a substantial nature must be provided for the guests by the
      host. For receptions, food of a substantial nature is equivalent to a minimum of three hors d'oeuvre portions per
      person attending
      the event for each hour of bar service.</p>
    <!-- <p>Bar service is limited to four hours. For events including a full meal service, one hour of wine service may be
      added during meal service. Bar service may begin no earlier than one hour prior to meal service and must end one
      hour prior to the
      end of the event.</p>
    <p>Due to the scope of the liquor licenses; changes to alcohol service times may only be accommodated if</p>
    <ul>
      <li>the request is submitted prior to the event start,</li>
      <li>TAM/TIPS certified staff are available, and</li>
      <li>all applicable charges are reviewed and accepted</li>
    </ul>
    <p>Under no circumstances can the overall alcohol service time exceed 4 hours of service or extend beyond the room
      reservation hours.</p> -->
    <p>Bar Service Guidelines for Events:</p>
    <ul>
      <li>Department and Student Events: Bar service is limited to four hours.</li>
      <li>Events Hosted by External Organizations: Alcohol service is limited to five hours.</li>
    </ul>
    <p>Important Time Restrictions:</p>
    <ul>
      <li>End Time: All alcohol service must end by 11:00 PM, regardless of the type of event.</li>
      <li>Meal Service: For department and commercial events with a full meal, you may add one hour of wine service during the meal.</li>
      <li>For external events, the wine service must be included in the five-hour maximum alcohol service time.</li>
      <li>Service Timing: Bar service can start no earlier than one hour before meal service begins and must end one hour before the event concludes.</li>
    </ul>
    <p>Changes to Service Times:</p>
    <ul>
      <li>Any changes to alcohol service times must be requested before the event starts.</li>
      <li>Changes can only happen if certified staff (TAM/TIPS) are available.</li>
      <li>All applicable charges must be reviewed and approved.</li>
    </ul>
    <p>All bartenders are trained in and observe the Techniques of Alcohol Management (TAM) and Training
      for Intervention Procedures (TIPS). In an effort to maintain
      the health and safety of guests, the following parameters apply to alcohol service.</p>
    <ul>
      <li>All drinks must be served with the appropriate amounts of mixers and ice. No straight shots of any liquor or
        combination of three or more liquors will be served.</li>
      <li>All beer, wine and mixed drinks will be provided in individual servings.</li>
    </ul>
    <p>In regard to alcohol service, University Unions reserves the following rights:</p>
    <ul>
      <li>to limit the maximum number of drinks an individual may purchase at one time.</li>
      <li>to deny alcoholic beverage service to anyone at any time.</li>
      <li>to recheck ID's.</li>
      <li>to shut down alcohol service entirely.</li>
    </ul>
  </section>
  <section>
    <h1 id="student-policy">Student Policies</h1>
    <p>These policies apply to Student Catering events hosted in the University Unions including the Michigan Union,
      Michigan League and Pierpont Commons.</p>
    <h2>General</h2>
    <p>All catered events are subject to:</p>
    <ul>
      <li>$35.00 minimum food and beverage sales</li>
      <li>State of Michigan sales tax</li>
      <li>20% Gratuity for served events</li>
    </ul>
    <p>To ensure quality of food and service, food and beverage orders should be confirmed three weeks prior to the
      event date. While every effort is made to accommodate last-minute requests, a minimum of one week&rsquo;s notice
      is generally required
      for all events.</p>
    <h2>Guest Guarantees</h2>
    <p>The final guaranteed count must be provided a minimum of six (6) business days prior to the event. The final
      charge will be based on the guaranteed count or actual number served, whichever is greater.</p>
    <h2>Late Orders and Changes</h2>
    <p>While every effort will be made to accommodate last minute requests, in order to ensure quality of food and
      service, we prefer a minimum of one week notice for events. Ideally, food and beverage should be confirmed three
      weeks prior to the event
      date. <strong>Orders received within six (6) business days of an event will be assessed a rush fee of
        $50</strong>.</p>
    <h2>Exclusivity Clause</h2>
    <p>MCatering has exclusivity for food and beverage service in University Unions. MCatering proceeds directly support 
      Student Life, including University Unions, offering transformational student experiences by advancing student 
      learning and development, fostering well-being, and cultivating an inclusive and equitable campus community. 
      MCatering proceeds support:</p>
    <ul>
      <li>Student programs and resources offered through the Division of Student Life in areas such as the Center for 
        Campus Involvement, Multi-Ethnic Student Affairs, the Spectrum Center, Trotter Multicultural Center, and the 
        International Center</li>
      <li>Wellness Services</li>
      <li>Educational opportunities for students, student employees, and student organizations</li>
      <li>Hundreds of student employment opportunities</li>
    </ul>
    <p>MCatering further supports the university's commitment to 
      <a href="https://dining.umich.edu/sustainability/social-sustainability/social-equity/">diversity, equity, and 
      inclusion in dining</a>; local purchasing; and is a leader in achieving 
      <a href="https://dining.umich.edu/sustainability/environmental-sustainability/">campus sustainability goals</a>.
    </p>
    <p>For groups requiring cultural and regional menu offerings, we encourage you to visit the International and 
      Regional Menus on the <a href="https://catering.umich.edu/">MCatering Website</a>.  MCatering understands that food 
      is connected to stories, identities, experiences, and familial traditions. In our Regional Menu, we have organized 
      offerings by region rather than country or ethnicity. We are open to feedback to help ensure what is offered on the 
      menus is culturally recognizable for your event. We know that recipes can be diasporic, and may be influenced by 
      other regions, recipes, and traditions worldwide. Please feel free to request menu items from multiple regions and 
      let us know what ethnicities and experiences are influencing your decisions so our team can create the ideal menu 
      for you. It is noted on the menu if recipes originated from students and what country that student identified. 
    </p>
    <h2>Menu Pricing</h2>
    <p>All prices are subject to change. Food and beverage pricing can be confirmed a maximum of two months in advance
      with menu selection.</p>
    <h2>Leftover Food</h2>
    <p>Due to health department regulations, leftover perishable foods may not be removed from any event by anyone
      except food service staff. This policy addresses public safety concerns and is non-negotiable. However,
      non-perishable items such as
      whole fruit, baked goods, and canned sodas may be taken from events. Michigan Catering works closely with Food
      Gatherers, Food Recovery Network and Maize and Blue Pantry to donate unused food items.</p>
    <h2>Service Times</h2>
    <p>Buffet menu quantities and perishable items are limited to a two-hour service period unless noted otherwise. Food
      items will be removed at the end of the contracted service period to ensure food quality.</p>
    <h2>Cancellations</h2>
    <p>While reasonable effort will be made to minimize cancellation charges, groups will be held responsible for all
      charges incurred as a result of any commitments made to facilitate the event. Events canceled within three
      business days may be
      charged up to 100% of the total estimated food and beverage charges.</p>
    <h2>Payment Policies</h2>
    <p>Student organizations must pay with a University of Michigan shortcode.</p>
    <p>Student organizations must deposit adequate funds to cover all charges in their S.O.A.S. accounts no later than
      one week prior to the scheduled event.</p>
    <h2>Serviceware</h2>
    <p>To maintain affordable pricing, Student Catering buffet menu items are served with disposable plates, cups and
      utensils. China, stemware and flatware are available for an additional charge.</p>
    <p>For plated and served menu items, china, stemware and flatware are provided.</p>
    <h2>Tables</h2>
    <p><strong>Michigan League</strong>: Five foot diameter round tables are available to seat 6-8 guests. We have a
      limited number of six foot diameter round tables that accommodate 9-10 guests.</p>
    <p><strong>Michigan Union</strong>: Six foot diameter round tables are available to seat up to 10 guests.</p>
    <h2>Table Linens</h2>
    <p>There is no charge for standard white 90&rdquo; square tablecloths.</p>
    <h2>Room Set-up</h2>
    <p>In general the room will be ready to receive decorations, musicians or disc jockeys approximately one hour prior
      to the start time of your event. Please let us know if this is not sufficient.</p>
    <h2>Nutrition</h2>
    <ul>
      <li>Please refer to <a href="http://fss.studentlife.umich.edu/NetNutrition/1" target="_blank"
          rel="noopener">MyNutrition</a> to identify allergens, nutritional values and ingredients for menu items. You
        may also contact one of our dietitians at
        <a href="tel:+17347643000">734-764-3000</a>.
      </li>
    </ul>
    <h2>Alcohol Service</h2>
    <p>For events hosted by student organizations or with an expected attendance of two-thirds or more students, the
      following conditions must be met:</p>
    <ul>
      <li>Division of Public Safety and Security officers and/or faculty or staff chaperons (determined by facility
        management)</li>
      <li>Non-transferable identification procedures (i.e. wrist banding - additional charges apply)</li>
      <li>Cash bar service only</li>
    </ul>
    <p>As a licensed facility, the University Unions are subject to all rules and regulations of the State of
      Michigan&rsquo;s Liquor Control Commission. No alcohol, other than that provided by Michigan Catering, may be
      served within our facilities.
      Additionally, no alcohol can be removed from the event room or University Unions facilities.</p>
    <p>At all events where alcohol will be served, the hosting organization will be notified of any special requirements
      relating to the service of alcohol. All associated expenses will be the responsibility of the hosting
      organization.</p>
    <p>At all events where alcohol will be served, the host must provide food of a substantial nature for the guests.
      For receptions, food of a substantial nature is equivalent to a minimum of three hors d&rsquo;oeuvre portions per
      person attending the
      event for each hour of bar service.</p>
    <!-- <p>Bar service is limited to four hours. For events including a full meal service, one hour of wine service may be
      added during meal service. Bar service may begin no earlier than one hour prior to meal service and must end one
      hour prior to the
      end of the event.</p>
    <p>Due to the scope of the liquor licenses; changes to alcohol service times may only be accommodated if</p>
    <ul>
      <li>The request is submitted prior to the event start</li>
      <li>TAM and TIPS certified staff are available</li>
      <li>All applicable charges are reviewed and accepted</li>
    </ul>
    <p>Under no circumstances can the overall alcohol service time exceed 5 hours of service or extend beyond the room
      reservation hours.</p> -->
    <p>Bar Service Guidelines for Events:</p>
    <ul>
      <li>Department and Student Events: Bar service is limited to four hours.</li>
      <li>Events Hosted by External Organizations: Alcohol service is limited to five hours.</li>
    </ul>
    <p>Important Time Restrictions:</p>
    <ul>
      <li>End Time: All alcohol service must end by 11:00 PM, regardless of the type of event.</li>
      <li>Meal Service: For department and commercial events with a full meal, you may add one hour of wine service during the meal.</li>
      <li>For external events, the wine service must be included in the five-hour maximum alcohol service time.</li>
      <li>Service Timing: Bar service can start no earlier than one hour before meal service begins and must end one hour before the event concludes.</li>
    </ul>
    <p>Changes to Service Times:</p>
    <ul>
      <li>Any changes to alcohol service times must be requested before the event starts.</li>
      <li>Changes can only happen if certified staff (TAM/TIPS) are available.</li>
      <li>All applicable charges must be reviewed and approved.</li>
    </ul>
    <p>All bartenders are trained in and observe the Techniques of Alcohol Management (TAM) and Training
      for Intervention Procedures (TIPS). In an effort to
      maintain the health and safety of guests, the following parameters apply to alcohol service:</p>
    <ul>
      <li>All drinks must be served with the appropriate amounts of mixers and ice</li>
      <li>No straight shots of any liquor or combination of three or more liquors will be served</li>
      <li>All beer, wine and mixed drinks will be provided in individual servings</li>
    </ul>

    <p>In regard to alcohol service, Michigan Catering reserves the following rights:</p>
    <ul>
      <li>to limit the maximum number of drinks an individual may purchase at one time</li>
      <li>to deny alcoholic beverage service to anyone at any time</li>
      <li>to recheck ID&rsquo;s</li>
      <li>to shut down alcohol service entirely.</li>
    </ul>
  </section>
</div>